import { Typography } from '@design-system/components/typography/typography';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';
import { Button } from '@design-system/components/button/button';
import { IconButton } from '@design-system/components/button/iconButton';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import { sprinkles } from '@design-system/sprinkles.css';

type LandingPageInfoProps = Pick<
  SubscriptionBundlesVM['priceEditModal'],
  'landingPage'
>;

export const LandingPageInfo = ({ landingPage }: LandingPageInfoProps) => (
  <div className="flex justify-between items-center">
    <div className="flex flex-col gap-2">
      <Typography variant="body" size="large">
        Landing page
      </Typography>
      <Typography variant="body" size="medium" color="N-80">
        Edit your automated channel page & share links
      </Typography>
    </div>
    <div className="flex gap-2">
      <IconButton
        variant="text"
        icon={faShareNodes}
        className={sprinkles({ color: 'P-80' })}
        onClick={landingPage.openLinksModal}
        disabled={landingPage.disableLinksModal}
      />
      <Button color="primaryTonal" onClick={landingPage.editLP}>
        Edit
      </Button>
    </div>
  </div>
);
